export default __webpack_public_path__ + "static/media/MotherImage.7c325c95.svg";